<template>
  <div class="panel">
    <div class="panel-header flex justify-between">
      <h2 class="panel-title">Update Postback</h2>
      <button @click="close">
        <v-icon name="io-close" />
      </button>
    </div>
    <div class="panel-body">
      <div class="relative flex flex-col space-y-4 rounded-md">
        <div>
          <div class="flex">
            <MultiSelect
              v-model="protocol"
              :options="protocolOptions"
              inputLabel="Protocol"
              label="label"
              trackBy="value"
              :multiple="false"
              class="!w-32"
              inputClass="first-item"
            >
            </MultiSelect>
            <XInput
              inputClass="!rounded-l-none"
              name="postback-url"
              id="postback-url"
              placeholder="yourpostback.url/?s1=your_s1_value&revenue=your_revenue_value"
              v-model="postbackUrl"
            />
          </div>
          <div class="text-xs mt-1 text-base-content/50">
            Available parameters are:
            <span class="text-primary"
              >{s1}, {s2}, {s3}, {s4}, {s5}, {revenue} (case insensitive)</span
            >
          </div>
        </div>
      </div>
      <div class="flex mt-4 justify-end">
        <XButton @click="save" color="primary" type="button"> Save </XButton>
      </div>
      {{ postback }}
    </div>
    <ValidationErrors
      v-if="validationErrors"
      :errors="validationErrors"
      teleport-to="#bottom-sticky"
    />
  </div>
</template>

<script setup>
import { ref, computed } from "vue"
import { useAuthStore } from "@/stores/auth.js"
import { useMutation, useQuery } from "@vue/apollo-composable"
import UPDATE_POSTBACK from "@/graphql/Postback/UpdatePostback.gql"
import POSTBACK_QUERY from "@/graphql/Postback/Postback.gql"
import ValidationErrors from "@/components/common/ValidationErrors.vue"
import { useValidationErrors } from "@/composables/useValidationErrors.js"


const { id } = defineProps({
  id: {
    type: [String, Number],
    required: true,
  },
})

const { validationErrors, setValidationErrors, clearValidationErrors } =
  useValidationErrors()


const protocolOptions = [
  {
    label: "https://",
    value: "https",
  },
  {
    label: "http://",
    value: "http",
  },
]

const authStore = useAuthStore()
const postbackUrl = ref("")
const protocol = ref(protocolOptions[0])

const emit = defineEmits(["close"])

const {
  result: postbackResult,
  loading: postbackLoading,
  onResult,
} = useQuery(POSTBACK_QUERY, {
  id: id,
})

onResult(result => {
  const postback = result?.data?.postback
  if (postback) {
    protocol.value = protocolOptions.find(
      option => option.value === postback.protocol,
    )
    postbackUrl.value = postback.url
  }
})

const postback = computed(() => {
  postbackResult.value?.postback
})

const close = () => {
  emit("close")
}

const isSaving = ref(false)

function save() {
  clearValidationErrors()
  isSaving.value = true
  const { mutate: savePostBack } = useMutation(UPDATE_POSTBACK)

  const input = {
    id: id,
    protocol: protocol?.value?.value ?? "https",
    url: postbackUrl.value ?? undefined,
  }

  savePostBack({
    input,
  })
    .then(({ data }) => {
      isSaving.value = false
      resetForm()
      close()
    })
    .catch(error => {
      setValidationErrors(error)
      isSaving.value = false
    })
}
function resetForm() {
  protocol.value = protocol[0]
  postbackUrl.value = ""
}
</script>
